import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { HashLink as Link } from 'react-router-hash-link'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Instagram from 'components/Frontpage/Instagram'
import Sidebar from 'components/Sidebar'
import Article from 'components/ArticleItem'
import Phaser from 'components/Phaser'
import HomeSubscribeForm from 'components/forms/HomeSubscribeForm'

const styles = (theme) => ({
  root: {
    paddingBottom: 20,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0,
    },
  },
  subheading: {
    color: '#fff',
    textTransform: 'uppercase',
    textAlign: 'center',
    fontWeight: 300,
    paddingBottom: 30,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
      maxHeight: 23,
      padding: 6,
      marginBottom: 7,
      fontWeight: 300,
    },
  },
  subscriberCta: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75em',
    },
  },
  left: {
    width: 950,
    [theme.breakpoints.down('md')]: {
      width: 670,
    },
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
    [theme.breakpoints.down('xs')]: {},
  },
  right: {
    width: 300,
    [theme.breakpoints.down('md')]: {
      width: 280,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  seeMoreWrapper: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'right',
    },
  },
})

const ArticlesSlide = ({
  classes,
  articles,
  tags,
  featuredStories,
  instagramPosts,
}) => (
  <Grid className={classes.root} spacing={24} justify="center" container>
    <Grid classes={{ item: classes.left }} item>
      <div>
        <Phaser label="Subscribe to our newsletters" upperCase noBottom />
        <Typography className={classes.subscriberCta}>
          Become a subscriber today to start receiving health newsletters
          delivered straight to your inbox. Never miss a single article! (You
          only need to enter your email. It's dead simple!)
        </Typography>
        <HomeSubscribeForm />
      </div>
      {instagramPosts && <Phaser label="Inspiration" upperCase />}
      {instagramPosts && <Instagram items={instagramPosts} />}
      <Phaser label="Latest Articles" upperCase />
      {articles.map(({ node }, i) => (
        <Article
          index={i}
          id={i === 0 && 'articles'}
          key={node.fields.slug}
          slug={node.fields.slug}
          timeToRead={node.timeToRead}
          excerpt={node.excerpt}
          title={node.frontmatter.title}
          uiTitle={node.frontmatter.uiTitle}
          date={node.frontmatter.date}
          src={node.frontmatter.thumbnail}
          category={node.frontmatter.category}
          pageType={node.frontmatter.pageType}
        />
      ))}
      <div className={classes.seeMoreWrapper}>
        <Link to="/weight-loss-articles">
          <Button variant="raised" color="primary" size="medium">
            See more
          </Button>
        </Link>
      </div>
    </Grid>
    <Grid classes={{ item: classes.right }} item>
      <Sidebar posts={articles} tags={tags} featuredStories={featuredStories} />
    </Grid>
  </Grid>
)

ArticlesSlide.propTypes = {
  classes: PropTypes.object.isRequired,
  articles: PropTypes.array.isRequired,
  tags: PropTypes.array.isRequired,
  featuredStories: PropTypes.object,
  instagramPosts: PropTypes.array,
}

export default withStyles(styles)(ArticlesSlide)



// WEBPACK FOOTER //
// ./src/components/Frontpage/ArticlesSlide.js